import actionTypes from '../common/actionTypes';

const settingsActions = {
	setQuestionnaireNavigationEnabled: (enabled: boolean) => {
		return { type: actionTypes.SET_QUESTIONNAIRE_NAVIGATION_ENABLED, enabled };
	},
	setSelectPlanOptionsEnabled: (enabled: boolean) => {
		return { type: actionTypes.SET_SELECT_POLICY_OPTIONS_ENABLED, enabled };
	}
};

export default settingsActions;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/settingsActions.ts